export const LOCATION_SERVICES_DISABLED = 'LOCATION_SERVICES_DISABLED';
export const LOCATION_PERMISSION_DENIED = 'LOCATION_PERMISSION_DENIED';
export const LOCATION_REQUEST_FUNCTION_MISSING = 'LOCATION_REQUEST_FUNCTION_MISSING';
export default class GeolocationData {
    constructor(geolocation) {
        const { latitude, longitude } = geolocation;
        this.rsuGpsAvailable = true;
        this.rsuLatitude = latitude;
        this.rsuLongitude = longitude;
    }
}
